import ClassOperation from '@/api/class-operation'
import MainProgram from '@/api/main-program'
import SubProgram from '@/api/sub-program'
import Academic from '@/api/report-academic'
import Branch from '@/api/branch'
import Term from '@/api/term-semester'
import Year from '@/api/academic-year'
import Grade from '@/api/grade'
import VehicleProfile from '@/api/vehicle-profile'
import StudentProfile from '@/api/student-profile'
import Employee from '@/api/employee'
import Level from '@/api/level'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  studentStatus: [],
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY'),
  start_date: moment().startOf('month').format('DD-MM-YYYY'),
  end_date: moment().endOf('month').format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_START_DATE(state, date) {
    state.start_date = date
  },
  SET_END_DATE(state, date) {
    state.end_date = date
  },
  SET_STATUS(state, data) {
    state.studentStatus = data
  }
}

export const actions = {
  getBranch(context, attributes = {}) {
    return Branch.get({
      params: {
        fields: {
          setup_branch_profiles: 'branch_id,branch_name_en'
        },
        filter: {
          user_branches: 1
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getMainProgram(context, attributes = {}) {
    return MainProgram.get({
      params: {
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubProgram(context, attributes = {}) {
    return SubProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getTerm(context, attributes = {}) {
    return Term.get({
      params: Object.assign(
        {
          fields: {
            academic_terms: 'ac_term_id,term_name,ac_status_id,term_order'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getTeacher(context, acp_id) {
    return ClassOperation.get({
      params: {
        include: 'teacher,academic_study_time',
        filter: {
          acp_id: acp_id,
          ac_status_id: 1
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getYear(context, attributes = {}) {
    return Year.get({
      params: Object.assign(
        {
          fields: {
            academic_years: 'ac_year_id,ac_year,ac_status_id'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getLevel(context, attributes = {}) {
    return Level.get({
      params: Object.assign(
        {
          fields: {
            academic_program_levels: 'level_id,level_name_foreign'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getClass(context, attributes = {}) {
    return ClassOperation.get({
      params: Object.assign(
        {
          include: 'teacher,academic_study_time,grade',
          fields: {
            academic_classes:
              'class_id,class_name,teacher_resp_id,ac_st_id,grade_id',
            teacher: 'teacher_id,fname_foreign,lname_foreign',
            academic_study_time: 'ac_st_id,study_time',
            grade: 'grade_id,grade_name_foreign'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getGrade(context, attributes = {}) {
    if (attributes.acps_id.length == 0) return
    return Grade.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_level_grades: 'grade_id,grade_name_foreign'
        },
        filter: {
          by_sub_program: attributes.acps_id
        },
        ...attributes
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  getVehicle(context, attributes = {}) {
    return VehicleProfile.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        include: 'operations,operations.driver',
        fields: {
          setup_transportation_vehicle_info: 'vehicle_id,plate_no'
        },
        ...attributes
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  async getStudentStatus(context) {
    if (!context.state.studentStatus.length > 0) {
      let response = await StudentProfile.getStatus()
      context.commit('SET_STATUS', response.data)
    }
  },
  // preview student list by class as PDF file
  studentList(context, attributes = {}) {
    return Academic.studentList({ params: attributes })
  },
  // generate student list as excel
  studentListExcel(context, data) {
    return Academic.studentListExcel(data)
  },
  // preview student list for dep't MoEYS by class as PDF file
  studentListForMoeys(context, attributes = {}) {
    return Academic.studentListForMoeys({ params: attributes })
  },
  // preview info inquiry student as PDF file
  infoInquiry(context, attributes = {}) {
    return Academic.infoInquiry({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // preview student transfer as PDF file
  studentTransfer(context, attributes = {}) {
    return Academic.studentTransfer({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // preview student enrollment as PDF file
  studentEnrollment(context, attributes = {}) {
    return Academic.studentEnrollment({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // preview transportation list as PDF file
  transportation(context, attributes = {}) {
    return Academic.transportation({ params: attributes })
  },
  // preview class teaching as PDF file
  classTeaching(context, attributes = {}) {
    return Academic.classTeaching({ params: attributes })
  },
  // preview info inquiry student as PDF file
  inactiveStudent(context, attributes = {}) {
    return Academic.inactiveStudent({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // preview student exchange as PDF file
  studentExchange(context, attributes = {}) {
    return Academic.studentExchange({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  async getStudentPofile(context, attributes = {}) {
    return StudentProfile.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        // fields: {
        //   academic_program_level_grades: 'grade_id,grade_name_foreign'
        // },
        filter: {
          student_in_class: attributes.student_in_class
        },
        ...attributes
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  // preview report card as PDF file
  reportCard(context, attributes = {}) {
    return Academic.reportCard({ params: attributes })
  },
  studentAchievementResult(context, attributes = {}) {
    return Academic.studentAchievementResult({ params: attributes })
  },
  async getScoringCycle(context, attributes = {}) {
    return Academic.getScoringCycle({ params: attributes })
  },
  async getScoringCycleValue(context, attributes = {}) {
    return await Academic.getScoringCycleValue({ params: attributes })
  },
  // preview class attendance as PDF file
  classAttendance(context, attributes = {}) {
    return Academic.classAttendance({
      params: Object.assign(
        {
          start_date: context.state.start_date,
          end_date: context.state.end_date
        },
        attributes
      )
    })
  },
  // generate class attendance as excel
  classAttendanceExcel(context, data) {
    return Academic.classAttendanceExcel(
      Object.assign(
        {
          start_date: context.state.start_date,
          end_date: context.state.end_date
        },
        data
      )
    )
  },
  getHeader(context, params) {
    return Academic.header({
      params: Object.assign(
        {
          start_date: context.state.start_date,
          end_date: context.state.end_date
        },
        params
      )
    })
  },
  getEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        setup_staff_information: 'staff_id,name_en,name_kh'
      },
      // filter: { in_registered_to_user_login: true },
      ...attributes
    }
    return Employee.get({
      params: params,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  // preview student Follow Up as PDF file
  studentFollowUp(context, attributes = {}) {
    return Academic.studentFollowUp({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  // preview report card as PDF file
  scoringReport(context, attributes = {}) {
    return Academic.scoringReport({ params: attributes })
  },
  // preview report card as Excel file
  scoringExport(context, data) {
    return Academic.scoringExport(data)
  },
  partTimeOfMonthly(context, attributes = {}) {
    return Academic.partTimeOfMonthly({ params: attributes })
  },
  studentScoreSheet(context, attributes = {}) {
    return Academic.studentScoreSheet({ params: attributes })
  },
  infoInquiryExcelRawData(context, { ...attributes }) {
    return Academic.infoInquiryExcelRawData(
      Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    )
  },
  // preview student performance report
  studentPerformance(context, attributes = {}) {
    return Academic.studentPerformance({ params: attributes })
  },
  // preview student total score performance report
  studentTotalScorePerformance(context, attributes = {}) {
    return Academic.studentTotalScorePerformance({ params: attributes })
  },
    // generate student list as excel
  studentListMoeysExcel(context, data) {
    return Academic.studentListMoeysExcel(data)
  },
}
